import styled from 'styled-components';
import { DESKTOP_BREAKPOINT, HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from '../../utils';

interface Props {
	$expanded?: boolean;
}

export const HeaderContainer = styled.header<Props>`
	height: ${HEADER_HEIGHT_DESKTOP}px;
	width: 100vw;
	background-color: ${({ theme }) => theme.colors.neutral.white};
	${({ theme }) => theme.boxShadow.primary};
	position: fixed;
	top: 0;
	z-index: 1100;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		height: ${(props) => (props.$expanded ? '228px' : `${HEADER_HEIGHT_MOBILE}px`)};
		transition: height 0.3s;
	}
`;

export const Nav = styled.nav`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: auto;
	padding: 0 16px;
	width: 1200px;
	height: 100%;

	a {
		display: flex;
		align-items: center;
	}

	img {
		width: 200px;
		margin: 0;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		width: 100%;
		flex-direction: column;
		align-items: flex-start;

		img {
			width: 130px;
		}
	}
`;

export const LeftDiv = styled.div`
	width: 100%;
	display: flex;
	align-items: center;

	a {
		height: 60px;
	}
`;

export const UserInfo = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 16px;
	font-size: 16px;
	gap: 4px;
`;

export const Ul = styled.ul`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	list-style: none;
	gap: 24px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: column;
		align-items: flex-start;
		margin-bottom: 16px;
		overflow: hidden;
	}
`;

export const Li = styled.li`
	a {
		text-decoration: none;
		font-size: 17px;
		font-weight: 600;
		color: ${({ theme }) => theme.colors.neutral.black};

		&:hover,
		&.active {
			color: ${({ theme }) => theme.colors.primary.medium};
			transition: 0.3s;
		}
	}
`;

export const InfoButton = styled.button`
	all: unset;
	cursor: pointer;
	display: flex;
	align-items: center;
	margin-left: 45px;
	font-size: 34px;
	color: ${({ theme }) => theme.colors.neutral.black};

	&:hover {
		color: ${({ theme }) => theme.colors.primary.medium};
		transition: 0.3s;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		display: none;
	}
`;

export const HambugerButton = styled(InfoButton)`
	display: none;

	&:hover {
		color: initial;
	}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		display: flex;
		flex: 1;
		justify-content: flex-end;
	}
`;
